import Swal from 'sweetalert2/dist/sweetalert2.min';
import AOS from 'aos/dist/aos';
import Vivus from 'vivus/dist/vivus.min';
import Swiper from 'swiper/bundle';

export default {
    $body: $('#body'),
        init: function () {
            $('ion-menu').removeClass('d-none');
            let splashHeight = $(document).find('.splash').outerHeight();
            let headerHeight = $('#header').outerHeight();

            function recalculateScroll(splashHeight, headerHeight)
            {
                $(window).scroll(() => {
                    let scrollTop = $(window).scrollTop();
                    if (scrollTop < (splashHeight - headerHeight)) {
                        $('#header').removeClass('gradient reduced');
                    } else {
                        $('#header').addClass('gradient reduced');
                    }
                }).scroll();
            }

            recalculateScroll(splashHeight, headerHeight);

            $(window).on('resizeend', function () {
                splashHeight = $(document).find('.splash').height();
                recalculateScroll(splashHeight, headerHeight);
            });

            $('[data-toggle="tooltip"]').tooltip();

            $('.select2').select2({
                theme: 'bootstrap4',
                width: '100%',
            });

            this.$body.find('#contact-form').on('submit', function (e) {
                e.preventDefault();
                let $form = $(this);
                $.post($form.attr('action'), $form.serialize(), function (res) {
                    $form.trigger('reset');
                    Swal.fire(
                        !res['error'] ? 'testo ringraziamento' : 'Errore',
                        !res['error'] ? 'testo ringraziamento' : res['error_message'],
                        !res['error'] ? 'success' : 'error'
                    ).then(() => false)
                }, 'json');
            });

            AOS.init({
                once: true,
                easing: 'ease-in-out',
                duration: 600,
            });


            if (this.$body.hasClass('homepage')
            ||
            this.$body.hasClass('work')
            ||
            this.$body.hasClass('life')
            ||
            this.$body.hasClass('blog')
            ||
            this.$body.hasClass('covid-safe')
                ||
                this.$body.hasClass('why-woliba')

            ) {
                new Vivus('woliba_w', {
                    duration: this.$body.hasClass('homepage') ? 250 : 100,
                    delay: this.$body.hasClass('homepage') ? 150 : 50,
                    animTimingFunction: Vivus.EASE_IN(),
                    onReady: function (vivus) {
                        vivus.el.style.visibility = 'inherit';
                    },
                }, null);
            }

            this.$body.find('.contact-call-list').find('.click-reveal').on('click', (e) => {
                let $this;
                $this = e.currentTarget;
                $($this).find('span').toggleClass('d-none');
            });

            const $swiperDefault = $('.swiper-default');
            if ($swiperDefault.length > 0) {
                let swiperInstances;
                swiperInstances = [];
                $swiperDefault.each(function (index) {
                    const $this = $(this);
                    $this.addClass('swiper-' + index);
                    $this.closest('.swiper-default').find('.swiper-pagination').addClass('pagination-' + index);
                    swiperInstances[index] = new Swiper('.swiper-' + index, {
                        grabCursor: true,
                        direction: 'horizontal',
                        speed: 850,
                        loop: false,
                        slidesPerView: 1,
                        centeredSlides: true,
                        spaceBetween: 24,
                        autoHeight: false,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren: true,
                        autoplay: {
                            delay: 10000,
                            disableOnInteraction: true,
                        },
                        pagination: {
                            el: '.pagination-' + index,
                            clickable: true,
                           /* renderBullet: function (index, className) {
                                return '<span class="' + className + '"><span class="swiper-pagination-number">' + ('0' + (index + 1)).slice(-2) + '</span></span>';
                            },*/
                        },
                    });
                });
                window.swiperInstances = swiperInstances;
                // console.log(window.swiperInstances);
            }
        },
    finalize() {
    },
    };



// WEBPACK FOOTER //
// ./scripts/routes/common.js